/* eslint-disable react/prop-types */
import { useSelector } from "react-redux";
import LocationOnIcon from '@mui/icons-material/LocationOn'; // Import the LocationOnIcon

import "./cards.css";
import DashboardDialogBox from "../DashboardDialogBox";
import { useState } from "react";
import { IconButton } from "@mui/material";

const Cards = ({ title, locationArea, plantations, plants, route, index, lat, long, plotLocation, plotCount }) => {
  const clickedCardIndex = useSelector((store) => store.utils?.clickedCards);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const coordinatesArray = [
    ...plotLocation.map(location => ({
      Latitude: parseFloat(location.Latitude),
      Longitude: parseFloat(location.Longitude),
      Altitude_meter: location.Altitude_meter || '', // Provide a default value or leave it empty as per your requirement
      Location: location.Plot_Name || null, // Provide a default value or leave it null as per your requirement
      plantTationCount: location.plantationCount,
      plantationLocations: location.plantationLocations,
      value: "plot"
    })),
    {
      Latitude: parseFloat(lat), // Parse lat as a float
      Longitude: parseFloat(long), // Parse long as a float
      Altitude_meter: '', // Provide a default value or leave it empty as per your requirement
      Location: title, // Provide a default value or leave it null as per your requirement
      plantTationCount: plotCount,
      value: "location"
    }
  ];
  
  return (
    <div
      className={`card-div ${clickedCardIndex[route] === index ? "bounce" : ""}`}
    >
      <div className="top-section">
        <div className="border"></div>
        <div className="location-icon"> {/* Add a container for the location icon */}

        </div>
        <div className="bottom-section">
          <span className="title">{title}<IconButton
            size="small"
            style={{ cursor: 'pointer', color: isHovered ? 'red' : '' }} // Set color based on hover state
            onMouseEnter={() => setIsHovered(true)} // Set hover state to true on mouse enter
            onMouseLeave={() => setIsHovered(false)} // Set hover state to false on mouse leave
            onClick={(e) => {
              e.stopPropagation(); // Stop event propagation
              setIsDialogOpen(true);
            }}
          >
            <LocationOnIcon /> {/* Add the LocationOnIcon */}
          </IconButton></span>
          <div className="row row1">
            <div className="item">
              <span className="big-text">{locationArea}</span>
              <span className="regular-text">Location Area (Hect.)</span>
            </div>
            <div className="item">
              <span className="big-text">{plantations}</span>
              <span className="regular-text">Plantation Area (Hect.)</span>
            </div>
            <div className="item">
              <span className="big-text">{plants}</span>
              <span className="regular-text">Total Plants</span>
            </div>
          </div>
          <DashboardDialogBox open={isDialogOpen} onClose={() => setIsDialogOpen(false)} coordinates={coordinatesArray} />
        </div>
      </div>
    </div>
  );
};

export default Cards;
